import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../../../services/http/http.service";
import { LoginService } from "./login-form.service";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { NgModule } from "@angular/core";
import Swal from "sweetalert2";
import { HttpErrorResponse } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
@Component({
  selector: "login-form",
  templateUrl: "./login-form.component.html",
  styleUrls: ["./login-form.component.scss"],
})
export class LoginFormComponent implements OnInit {
  loginForm: FormGroup;
  loadingLoginForm: boolean;
  errorMessage;
  constructor(
    private fb: FormBuilder,
    private loginService: LoginService,
    private router: Router,
    private http: HttpClient
  ) { }

  ngOnInit() {
    localStorage.clear();
    this.loginForm = this.fb.group({
      login: ["", Validators.required],
      pass: ["", Validators.required],
    });
  }

  loginFormSubmit() {
    this.loadingLoginForm = true;
    if (this.loginForm.invalid) {
      return;
    }
    else{
      this.loginForm.value.login = this.loginForm.value.login.trim();
      this.loginForm.value.pass = this.loginForm.value.pass.trim();
    }
    if (
      this.loginForm.value.login.includes("@foodbud.ai")
      ||
      this.loginForm.value.login.includes("sujal@digitaladvantagemedia.com")
      
    ) {
      let loginObj = {
        username: this.loginForm.value.login,
        password: this.loginForm.value.pass,
        type: "SUPERADMIN",
      };
      console.log(loginObj);
      this.http
        .post(environment.superAdminLoginUrl + "login", loginObj)
        .subscribe(
          (response) => {
            if (response["status"] == true) {
              const data = {
                accessToken: response["result"].authToken,
                restoID: response["result"].userDetails.userID,
              };
              localStorage.setItem("access_token", data.accessToken);
              localStorage.setItem("restoID", data.restoID);
              localStorage.setItem("currentUser", JSON.stringify(data));
              this.router.navigate(["superadmin/dashboard"]);
              this.loadingLoginForm = false;
              // console.log(response["result"].authToken);
            } else {
              Swal.fire("Something Went Wrong");
            }
          },
          (err: HttpErrorResponse) => {
            this.errorMessage = err.error["data"].message;
            Swal.fire(this.errorMessage);
          }
        );

      // console.log(loginObj);
    }

    else if (this.loginForm.value.login.includes("@")) {
      let loginObj = {
        login: this.loginForm.value.login,
        pass: this.loginForm.value.pass,
        type: "MASTER_RESTAURANT",
      };
      console.log(loginObj);
      this.loginService.postLogin(loginObj)
        .subscribe(
          (response) => {
            if (response["status"] == true) {
              const data = {
                accessToken: response["result"].authToken,
                restoID: response["result"].userDetails.userID,
              };
              localStorage.setItem("access_token", data.accessToken);
              localStorage.setItem("restoID", data.restoID);
              localStorage.setItem("currentUser", JSON.stringify(data));
              this.router.navigate(["details/masterRestoDetails"]);
              sessionStorage.setItem("master_user_data", JSON.stringify(response["result"]));
              this.loadingLoginForm = false;
              // console.log(response["result"].authToken);
            } else {
              Swal.fire("Something Went Wrong");
            }
          },
          (err: HttpErrorResponse) => {
            this.errorMessage = err.error["data"].message;
            Swal.fire(this.errorMessage);
          }
        );

      // console.log(loginObj);
    }


    else {
      console.log(this.loginForm.value.login.includes("@"))
      console.log(this.loginForm.value.login)
      this.loginService.postLogin(this.loginForm.value).subscribe(
        (response) => {
          if (response["status"] == true) {
            const data = {
              accessToken: response.result.authToken,
              restoID: response.result.userDetails.restaurant_id,
            };
            localStorage.setItem("access_token", data.accessToken);
            localStorage.setItem("restoID", data.restoID);
            localStorage.setItem("currentUser", JSON.stringify(data));
            if (response['result'].userDetails.level_of_restaurant == 'L1') {
              this.router.navigate(["details/restoDetails"]);
            } else {
              this.router.navigate(["horizontal/main"]);
            }
            this.loadingLoginForm = false;
            // this.toastr.success(response['message'], 'Success');
          } else {
            Swal.fire("Something Went Wrong");
          }
        },
        (err: HttpErrorResponse) => {
          this.errorMessage = err.error["data"].message;
          Swal.fire(this.errorMessage);
        }
      );
    }
    // console.log(this.loginForm.value);
  }
}
